export default "__VITE_ASSET__DkIOBi9K__"